import { render, staticRenderFns } from "./editWindowAdmin.vue?vue&type=template&id=4474d62f"
import script from "./editWindowAdmin.vue?vue&type=script&lang=js"
export * from "./editWindowAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports